var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _vm.formValidate.type === _vm.OrderSecondTypeEnum.PunchCard
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "核销次数：", required: "" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          "controls-position": "right",
                          step: 1,
                          "step-strictly": "",
                          min: 1,
                          disabled: _vm.isDisabled,
                        },
                        model: {
                          value: _vm.formValidate.verifyQuantity,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "verifyQuantity", $$v)
                          },
                          expression: "formValidate.verifyQuantity",
                        },
                      }),
                      _c("div", { staticClass: "from-tips" }, [
                        _vm._v(
                          "用户可以核销的次数，一次性购买多个商品则取总和次数"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "核销时效：", required: "" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.isDisabled },
                          on: { input: _vm.changeVerifyTimeType },
                          model: {
                            value: _vm.formValidate.verifyTimeLimitType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formValidate,
                                "verifyTimeLimitType",
                                $$v
                              )
                            },
                            expression: "formValidate.verifyTimeLimitType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("永久有效"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("购买几天后有效"),
                          ]),
                          _c("el-radio", { attrs: { label: 3 } }, [
                            _vm._v("固定有效期"),
                          ]),
                        ],
                        1
                      ),
                      _vm.formValidate.verifyTimeLimitType === 2
                        ? _c(
                            "div",
                            [
                              _c("el-input-number", {
                                attrs: {
                                  "controls-position": "right",
                                  step: 1,
                                  "step-strictly": "",
                                  min: 1,
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.verifyTimeLimitDay,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate,
                                      "verifyTimeLimitDay",
                                      $$v
                                    )
                                  },
                                  expression: "formValidate.verifyTimeLimitDay",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.formValidate.verifyTimeLimitType === 3
                        ? _c(
                            "div",
                            [
                              _c("el-date-picker", {
                                staticClass: "mr20",
                                staticStyle: { width: "360px" },
                                attrs: {
                                  type: "daterange",
                                  size: "small",
                                  clearable: false,
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "value-format": "yyyy-MM-dd",
                                  disabled: _vm.isDisabled,
                                  "picker-options": _vm.pickerOptions,
                                },
                                model: {
                                  value: _vm.punchCardTimeVal,
                                  callback: function ($$v) {
                                    _vm.punchCardTimeVal = $$v
                                  },
                                  expression: "punchCardTimeVal",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "佣金设置：", props: "isSub", required: "" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.isDisabled },
                      on: { change: _vm.changeAttrVal },
                      model: {
                        value: _vm.formValidate.isSub,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValidate, "isSub", $$v)
                        },
                        expression: "formValidate.isSub",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: true } },
                        [_vm._v("单独设置")]
                      ),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("默认设置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "会员价类型：", required: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.isDisabled },
                      on: { change: _vm.changeAttrVal },
                      model: {
                        value: _vm.formValidate.vipPriceType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValidate, "vipPriceType", $$v)
                        },
                        expression: "formValidate.vipPriceType",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: 0 } },
                        [_vm._v("无")]
                      ),
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: 1 } },
                        [_vm._v("svip价")]
                      ),
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: 2 } },
                        [_vm._v("商户会员价")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formValidate.type !== _vm.OrderSecondTypeEnum.PunchCard
                ? _c(
                    "el-form-item",
                    { attrs: { label: "规格类型：", props: "specType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.isDisabled },
                          on: {
                            change: function ($event) {
                              return _vm.onChangeSpec(_vm.formValidate.specType)
                            },
                          },
                          model: {
                            value: _vm.formValidate.specType,
                            callback: function ($$v) {
                              _vm.$set(_vm.formValidate, "specType", $$v)
                            },
                            expression: "formValidate.specType",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            { staticClass: "radio", attrs: { label: false } },
                            [_vm._v("单规格")]
                          ),
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("多规格"),
                          ]),
                        ],
                        1
                      ),
                      _vm.formValidate.specType &&
                      _vm.ruleList.length &&
                      _vm.formValidate.type !==
                        _vm.OrderSecondTypeEnum.Reservation
                        ? _c(
                            "el-dropdown",
                            {
                              staticClass: "ml20 dropdown-menu-box",
                              attrs: {
                                disabled: _vm.isDisabled,
                                trigger: "hover",
                              },
                              on: { command: _vm.confirm },
                            },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _vm._v(" 选择规格模板"),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right",
                                }),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                _vm._l(_vm.ruleList, function (item, index) {
                                  return _c(
                                    "el-dropdown-item",
                                    {
                                      key: index,
                                      attrs: { command: item.ruleName },
                                    },
                                    [_vm._v(_vm._s(item.ruleName))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.formValidate.specType && !_vm.isDisabled
            ? _c(
                "el-col",
                { staticClass: "noForm", attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: "商品规格：" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.formValidate.attrs.length,
                            expression: "formValidate.attrs.length",
                          },
                        ],
                        staticClass: "from-tips mb20",
                        staticStyle: { "margin-top": "9px" },
                      },
                      [_vm._v(" 勾选添加规格图，当前规格图片必须上传 ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "specifications" },
                      [
                        _c(
                          "draggable",
                          {
                            attrs: {
                              group: "specifications",
                              disabled: _vm.formValidate.attrs.length < 2,
                              list: _vm.formValidate.attrs,
                              handle: ".move-icon",
                              animation: "300",
                            },
                            on: { end: _vm.onMoveSpec },
                          },
                          _vm._l(
                            _vm.formValidate.attrs,
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "specifications-item active",
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeCurrentIndex(index)
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "move-icon" }, [
                                    _c("span", {
                                      staticClass: "iconfont icon-drag2",
                                    }),
                                  ]),
                                  _c("i", {
                                    staticClass: "del el-icon-error",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleRemoveRole(
                                          index,
                                          item.value
                                        )
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "specifications-item-box" },
                                    [
                                      _c("div", { staticClass: "lineBox" }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "specifications-item-name mb18",
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "specifications-item-name-input",
                                            attrs: {
                                              size: "small",
                                              placeholder: "规格名称",
                                              maxlength: "30",
                                              "show-word-limit": "",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.attrChangeValue(
                                                  index,
                                                  item.value
                                                )
                                              },
                                              focus: function ($event) {
                                                return _vm.handleFocus(
                                                  item.value
                                                )
                                              },
                                            },
                                            model: {
                                              value: item.value,
                                              callback: function ($$v) {
                                                _vm.$set(item, "value", $$v)
                                              },
                                              expression: "item.value",
                                            },
                                          }),
                                          _c(
                                            "el-checkbox",
                                            {
                                              staticClass: "ml20",
                                              attrs: {
                                                disabled:
                                                  !item.add_pic && !_vm.canSel,
                                                "true-label": 1,
                                                "false-label": 0,
                                              },
                                              on: {
                                                change: function (e) {
                                                  return _vm.addPic(e, index)
                                                },
                                              },
                                              model: {
                                                value: item.add_pic,
                                                callback: function ($$v) {
                                                  _vm.$set(item, "add_pic", $$v)
                                                },
                                                expression: "item.add_pic",
                                              },
                                            },
                                            [_vm._v("添加规格图")]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                content:
                                                  "添加规格图片, 仅支持打开一个(建议尺寸:800*800),勾选后,当前规格图片必须上传",
                                                placement: "right",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-info",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "rulesBox ml-30" },
                                        [
                                          _c(
                                            "draggable",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                list: item.detail,
                                                disabled:
                                                  item.detail.length < 2,
                                                handle: ".drag",
                                              },
                                              on: { end: _vm.onMoveSpec },
                                            },
                                            [
                                              _vm._l(
                                                item.detail,
                                                function (det, indexn) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: indexn,
                                                      staticClass:
                                                        "mr10 spec drag",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-error",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleRemove2(
                                                              item.detail,
                                                              indexn,
                                                              det.value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _c(
                                                        "el-input",
                                                        {
                                                          staticStyle: {
                                                            width: "430px",
                                                          },
                                                          attrs: {
                                                            size: "small",
                                                            placeholder:
                                                              "规格值",
                                                            maxlength: "30",
                                                            "show-word-limit":
                                                              "",
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              return _vm.attrDetailChangeValue(
                                                                det.value,
                                                                index
                                                              )
                                                            },
                                                            focus: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleFocus(
                                                                det.value
                                                              )
                                                            },
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleBlur()
                                                            },
                                                          },
                                                          model: {
                                                            value: det.value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                det,
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "det.value",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "prefix" },
                                                            [
                                                              _c("span", {
                                                                staticClass:
                                                                  "iconfont icon-drag2",
                                                              }),
                                                            ]
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                      item.add_pic
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "img-popover",
                                                            },
                                                            [
                                                              _c("div", {
                                                                staticClass:
                                                                  "popper-arrow",
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "popper",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleSelImg(
                                                                          det,
                                                                          indexn
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  det.image
                                                                    ? _c(
                                                                        "el-image",
                                                                        {
                                                                          staticClass:
                                                                            "image",
                                                                          attrs:
                                                                            {
                                                                              src: det.image,
                                                                              fit: "cover",
                                                                            },
                                                                        }
                                                                      )
                                                                    : _c("i", {
                                                                        staticClass:
                                                                          "el-icon-plus",
                                                                      }),
                                                                ],
                                                                1
                                                              ),
                                                              det.image
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "img-del el-icon-error",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleRemoveImg(
                                                                            det
                                                                          )
                                                                        },
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-popover",
                                                    {
                                                      ref:
                                                        "popoverRef_" + index,
                                                      refInFor: true,
                                                      attrs: {
                                                        placement: "",
                                                        width: "420",
                                                        trigger: "click",
                                                      },
                                                      on: {
                                                        "after-enter":
                                                          function ($event) {
                                                            return _vm.handleShowPop(
                                                              index
                                                            )
                                                          },
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        ref:
                                                          "inputRef_" + index,
                                                        refInFor: true,
                                                        attrs: {
                                                          size: "small",
                                                          placeholder:
                                                            "请输入规格值",
                                                          maxlength: "30",
                                                          "show-word-limit": "",
                                                        },
                                                        on: {
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.createAttr(
                                                              _vm.formDynamic
                                                                .attrsVal,
                                                              index
                                                            )
                                                          },
                                                        },
                                                        nativeOn: {
                                                          keyup: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              !$event.type.indexOf(
                                                                "key"
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "enter",
                                                                13,
                                                                $event.key,
                                                                "Enter"
                                                              )
                                                            ) {
                                                              return null
                                                            }
                                                            return _vm.createAttr(
                                                              _vm.formDynamic
                                                                .attrsVal,
                                                              index
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.formDynamic
                                                              .attrsVal,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.formDynamic,
                                                              "attrsVal",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formDynamic.attrsVal",
                                                        },
                                                      }),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "addfont",
                                                          attrs: {
                                                            slot: "reference",
                                                          },
                                                          slot: "reference",
                                                        },
                                                        [_vm._v("添加规格值")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        (_vm.formValidate.type ===
                          _vm.OrderSecondTypeEnum.Reservation &&
                          _vm.formValidate.attrs.length === 0) ||
                        _vm.formValidate.type !==
                          _vm.OrderSecondTypeEnum.Reservation
                          ? _c(
                              "el-button",
                              { on: { click: _vm.handleAddRole } },
                              [_vm._v("添加新规格")]
                            )
                          : _vm._e(),
                        _vm.formValidate.attrs.length >= 1
                          ? _c(
                              "el-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSaveAsTemplate()
                                  },
                                },
                              },
                              [_vm._v("另存为模板")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.formValidate.type === _vm.OrderSecondTypeEnum.Reservation
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "时段划分：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.isDisabled },
                          model: {
                            value:
                              _vm.formValidate.supplementReservation
                                .timeSlotClassifyType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formValidate.supplementReservation,
                                "timeSlotClassifyType",
                                $$v
                              )
                            },
                            expression:
                              "formValidate.supplementReservation.timeSlotClassifyType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("自动划分"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("自定义划分"),
                          ]),
                        ],
                        1
                      ),
                      _vm.formValidate.supplementReservation
                        .timeSlotClassifyType == 1
                        ? _c(
                            "div",
                            { staticClass: "reservation-times-box font12" },
                            [
                              _vm._v(" 起止时间： "),
                              _c("el-time-picker", {
                                staticClass: "mr10",
                                staticStyle: { width: "200px" },
                                attrs: {
                                  "is-range": "",
                                  "value-format": "HH:mm",
                                  format: "HH:mm",
                                  placeholder: "选择时间",
                                  size: "mini",
                                  clearable: false,
                                  disabled: _vm.isDisabled,
                                },
                                on: { change: _vm.reservationTimesChange },
                                model: {
                                  value:
                                    _vm.formValidate.temporaryData
                                      .reservationTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate.temporaryData,
                                      "reservationTime",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formValidate.temporaryData.reservationTime",
                                },
                              }),
                              _vm._v(" 间隔时间： "),
                              _c("el-input-number", {
                                staticClass: "mr10",
                                attrs: {
                                  min: 10,
                                  max: 1440,
                                  precision: 0,
                                  size: "small",
                                  "controls-position": "right",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value:
                                    _vm.formValidate.supplementReservation
                                      .timeSlotSpan,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate.supplementReservation,
                                      "timeSlotSpan",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formValidate.supplementReservation.timeSlotSpan",
                                },
                              }),
                              _c("span", { staticClass: "from-tips mr10" }, [
                                _vm._v("支持设置10-1440分钟"),
                              ]),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "debounceClick",
                                      rawName: "v-debounceClick",
                                      value: _vm.generateTimeSlots,
                                      expression: "generateTimeSlots",
                                    },
                                  ],
                                  class: { flash: _vm.isFlashing },
                                  attrs: {
                                    size: "small",
                                    disabled: _vm.isDisabled,
                                    type: "primary",
                                  },
                                },
                                [_vm._v("确认时间段")]
                              ),
                              _vm.formValidate.timeSlotAutomatic.length
                                ? _c(
                                    "div",
                                    { staticClass: "flex mt5" },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          attrs: {
                                            indeterminate: _vm.isIndeterminate,
                                          },
                                          on: { change: _vm.handleCheckAll },
                                          model: {
                                            value: _vm.timeCheckAll,
                                            callback: function ($$v) {
                                              _vm.timeCheckAll = $$v
                                            },
                                            expression: "timeCheckAll",
                                          },
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          staticClass: "flex-1",
                                          on: {
                                            change: _vm.checkAllGroupChange,
                                          },
                                          model: {
                                            value: _vm.timeCheckGroup,
                                            callback: function ($$v) {
                                              _vm.timeCheckGroup = $$v
                                            },
                                            expression: "timeCheckGroup",
                                          },
                                        },
                                        _vm._l(
                                          _vm.formValidate.timeSlotAutomatic,
                                          function (item, index) {
                                            return _c(
                                              "el-checkbox",
                                              {
                                                key: item.timeSlot,
                                                staticClass: "ml20",
                                                attrs: { label: item.timeSlot },
                                              },
                                              [_vm._v(_vm._s(item.timeSlot))]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.formValidate.supplementReservation
                        .timeSlotClassifyType == 2
                        ? _c("div", { staticClass: "reservation-times-box" }, [
                            _c("div", { staticClass: "from-tips" }, [
                              _vm._v(
                                "请依照时间的先后顺序添加时段，并且时段的开始时间不得早于上一个时段的结束时间。"
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "acea-row mt10 customize-time" },
                              [
                                _vm._l(
                                  _vm.formValidate.temporaryData
                                    .customizeTimeClone,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "flex relative",
                                      },
                                      [
                                        _c("el-time-picker", {
                                          key: index,
                                          staticClass: "mr10 mb10",
                                          staticStyle: { width: "200px" },
                                          attrs: {
                                            "is-range": "",
                                            "value-format": "HH:mm",
                                            format: "HH:mm",
                                            placeholder: "选择时间",
                                            placement: "bottom-end",
                                            clearable: false,
                                            size: "mini",
                                          },
                                          on: {
                                            change: _vm.changeCustomizeTime,
                                          },
                                          model: {
                                            value:
                                              _vm.formValidate.temporaryData
                                                .customizeTimeClone[index],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formValidate.temporaryData
                                                  .customizeTimeClone,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formValidate.temporaryData.customizeTimeClone[index]",
                                          },
                                        }),
                                        _vm.formValidate.temporaryData
                                          .customizeTimeClone &&
                                        _vm.formValidate.temporaryData
                                          .customizeTimeClone.length > 1
                                          ? _c("div", {
                                              staticClass: "el-icon-error",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.closeTime(index)
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _vm.formValidate.temporaryData
                                  .customizeTimeClone &&
                                _vm.formValidate.temporaryData
                                  .customizeTimeClone.length < 24
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "add-time font12",
                                        attrs: { disabled: _vm.isDisabled },
                                        on: { click: _vm.addTime },
                                      },
                                      [
                                        _vm._v(
                                          "添加时段（" +
                                            _vm._s(
                                              _vm.formValidate.temporaryData
                                                .customizeTimeClone.length
                                            ) +
                                            "/24）"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "debounceClick",
                                        rawName: "v-debounceClick",
                                        value: _vm.setCustomizeTime,
                                        expression: "setCustomizeTime",
                                      },
                                    ],
                                    staticClass: "ml10 mb20",
                                    class: { flash: _vm.isFlashing },
                                    attrs: {
                                      disabled: _vm.isDisabled,
                                      size: "mini",
                                      type: "primary",
                                    },
                                  },
                                  [_vm._v("确认时间段")]
                                ),
                              ],
                              2
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { xl: 24, lg: 24, md: 24, sm: 24, xs: 24 } },
            [
              _vm.formValidate.specType === false
                ? _c(
                    "el-form-item",
                    [
                      _c("el-alert", {
                        attrs: {
                          title: "价格设置范围 0.01~999999.99",
                          type: "info",
                        },
                      }),
                      _c(
                        "el-table",
                        {
                          staticClass: "tabNumWidth",
                          attrs: {
                            data: _vm.OneattrValue,
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "图片",
                              width: "60",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "upLoadPicBox",
                                          on: {
                                            click: function ($event) {
                                              return _vm.modalPicTap(
                                                false,
                                                "dan",
                                                "pi"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          scope.row.image
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "pictrue tabPic",
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: scope.row.image,
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass: "upLoad tabPic",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-camera cameraIconfont",
                                                  }),
                                                ]
                                              ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2499745365
                            ),
                          }),
                          _vm.formValidate.isSub
                            ? [
                                _c("el-table-column", {
                                  attrs: {
                                    label: "一级返佣(%)",
                                    "min-width": "120",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-input", {
                                              staticClass: "priceBox",
                                              attrs: {
                                                maxlength: "6",
                                                disabled: _vm.isDisabled,
                                                min: "0",
                                              },
                                              nativeOn: {
                                                keyup: function ($event) {
                                                  return _vm.keyupEventBrokerage(
                                                    "brokerage",
                                                    scope.$index,
                                                    2
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.brokerage,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "brokerage",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.brokerage",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4137747993
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "二级返佣(%)",
                                    "min-width": "120",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-input", {
                                              staticClass: "priceBox",
                                              attrs: {
                                                maxlength: "6",
                                                disabled: _vm.isDisabled,
                                                min: "0",
                                              },
                                              nativeOn: {
                                                keyup: function ($event) {
                                                  return _vm.keyupEventBrokerage(
                                                    "brokerageTwo",
                                                    scope.$index,
                                                    2
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.brokerageTwo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "brokerageTwo",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.brokerageTwo",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4066313593
                                  ),
                                }),
                              ]
                            : _vm._e(),
                          _vm._l(_vm.tableAttrValue, function (item, iii) {
                            return _c("el-table-column", {
                              key: iii,
                              attrs: {
                                label: _vm.oneAttrFormThead(iii),
                                "min-width": "160",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        iii === "barCode" ||
                                        iii === "itemNumber"
                                          ? _c("el-input", {
                                              staticClass: "priceBox",
                                              attrs: {
                                                disabled: _vm.isDisabled,
                                                maxlength: "40",
                                                type: "test",
                                                readonly: false,
                                              },
                                              model: {
                                                value: scope.row[iii],
                                                callback: function ($$v) {
                                                  _vm.$set(scope.row, iii, $$v)
                                                },
                                                expression: "scope.row[iii]",
                                              },
                                            })
                                          : _c("el-input-number", {
                                              attrs: {
                                                disabled:
                                                  _vm.isDisabled ||
                                                  (iii === "stock" &&
                                                  _vm.formValidate.type == 6
                                                    ? true
                                                    : false),
                                                min:
                                                  iii === "stock" ||
                                                  iii === "weight" ||
                                                  iii === "volume"
                                                    ? 0
                                                    : 0.01,
                                                max:
                                                  _vm.formValidate
                                                    .vipPriceType &&
                                                  iii === "vipPrice"
                                                    ? Number(scope.row.price) -
                                                      0.01
                                                    : 999999.99,
                                                step:
                                                  iii === "stock" ? 1 : 0.01,
                                                "controls-position": "right",
                                                "step-strictly": "",
                                              },
                                              model: {
                                                value: scope.row[iii],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    iii,
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "scope.row[iii]",
                                              },
                                            }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          }),
                          _vm.formValidate.type == 5
                            ? [
                                _c("el-table-column", {
                                  attrs: {
                                    label: "云盘设置",
                                    "min-width": "120",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            !scope.row.expand
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: { size: "small" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleAddVirtually(
                                                          0,
                                                          "OneattrValue",
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("添加链接")]
                                                )
                                              : _c(
                                                  "el-button",
                                                  {
                                                    staticClass:
                                                      "seeCatMy pointer",
                                                    attrs: {
                                                      type: "text",
                                                      size: "small",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.seeVirtually(
                                                          _vm.OneattrValue[0],
                                                          "OneattrValue",
                                                          0,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("已设置")]
                                                ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    67553566
                                  ),
                                }),
                              ]
                            : _vm._e(),
                          _vm.formValidate.type == 6
                            ? [
                                _c("el-table-column", {
                                  attrs: {
                                    label: "卡密设置",
                                    "min-width": "120",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            !scope.row.cdkeyId
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: { size: "small" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleAddVirtually(
                                                          0,
                                                          "OneattrValue",
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("添加卡密")]
                                                )
                                              : _c(
                                                  "el-button",
                                                  {
                                                    staticClass:
                                                      "seeCatMy pointer",
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.seeVirtually(
                                                          _vm.OneattrValue[0],
                                                          "OneattrValue",
                                                          0,
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row
                                                          .cdkeyLibraryName
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3649429042
                                  ),
                                }),
                              ]
                            : _vm._e(),
                          _vm.formValidate.type == 7
                            ? [
                                _c("el-table-column", {
                                  attrs: {
                                    label: "预约设置",
                                    "min-width": "180",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                class: {
                                                  flash: _vm.isFlashing,
                                                },
                                                attrs: { size: "small" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleSetReservationNum(
                                                      0,
                                                      _vm.OneattrValue
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("设置可约数量")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2332247614
                                  ),
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formValidate.attrs.length > 0 && _vm.formValidate.specType
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "labeltop",
                      class: _vm.isDisabled ? "disLabel" : "disLabelmoren",
                      attrs: { label: "商品属性：" },
                    },
                    [
                      _c("el-alert", {
                        attrs: {
                          title: "价格设置范围 0.01~999999.99",
                          type: "info",
                        },
                      }),
                      _c(
                        "el-table",
                        {
                          key: _vm.tableKey,
                          staticClass: "tabNumWidth",
                          attrs: {
                            data: _vm.ManyAttrValue,
                            border: "",
                            size: "small",
                            "span-method": _vm.objectSpanMethod,
                            "cell-class-name": _vm.tableCellClassName,
                          },
                        },
                        _vm._l(_vm.formValidate.header, function (item, index) {
                          return _c("el-table-column", {
                            key: index,
                            attrs: {
                              label: item.title,
                              "min-width": item.minWidth || "200",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.$index == 0
                                        ? [
                                            item.key
                                              ? [
                                                  _vm.formValidate.attrs
                                                    .length &&
                                                  _vm.formValidate.attrs[
                                                    scope.column.index
                                                  ] &&
                                                  _vm.ManyAttrValue.length
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "el-select",
                                                            {
                                                              attrs: {
                                                                placeholder:
                                                                  "请选择" +
                                                                  item.title,
                                                                clearable: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .oneFormBatch[0][
                                                                    item.title
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .oneFormBatch[0],
                                                                      item.title,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "oneFormBatch[0][item.title]",
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.formValidate
                                                                .attrs[
                                                                scope.column
                                                                  .index
                                                              ].detail,
                                                              function (val) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: val.value,
                                                                    attrs: {
                                                                      label:
                                                                        val.value,
                                                                      value:
                                                                        val.value,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              : item.slot === "image"
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "upLoadPicBox specPictrue",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.modalPicTap(
                                                            false,
                                                            "pi",
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm.oneFormBatch[0].image
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad tabPic",
                                                            },
                                                            [
                                                              _c("img", {
                                                                directives: [
                                                                  {
                                                                    name: "lazy",
                                                                    rawName:
                                                                      "v-lazy",
                                                                    value:
                                                                      _vm
                                                                        .oneFormBatch[0]
                                                                        .image,
                                                                    expression:
                                                                      "oneFormBatch[0].image",
                                                                  },
                                                                ],
                                                              }),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad tabPic",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-camera cameraIconfont",
                                                              }),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              : item.slot === "brokerage" &&
                                                _vm.formValidate.isSub
                                              ? [
                                                  _c("el-input", {
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .brokerage,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "brokerage",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].brokerage",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "brokerageTwo" &&
                                                _vm.formValidate.isSub
                                              ? [
                                                  _c("el-input", {
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .brokerageTwo,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "brokerageTwo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].brokerageTwo",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "price"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0.01,
                                                      max: 999999.99,
                                                      step: 0.01,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .price,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "price",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].price",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "vipPrice" &&
                                                _vm.formValidate.vipPriceType
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0.01,
                                                      max: 999999.99,
                                                      step: 0.01,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .vipPrice,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "vipPrice",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].vipPrice",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "cost"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0.01,
                                                      max: 999999.99,
                                                      step: 0.01,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .cost,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "cost",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].cost",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "otPrice"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0.01,
                                                      max: 999999.99,
                                                      step: 0.01,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .otPrice,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "otPrice",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].otPrice",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "stock" &&
                                                _vm.formValidate.type !==
                                                  _vm.OrderSecondTypeEnum
                                                    .Reservation
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      disabled:
                                                        _vm.formValidate
                                                          .type ===
                                                        _vm.OrderSecondTypeEnum
                                                          .CardPassword
                                                          ? true
                                                          : false,
                                                      min: 0,
                                                      step: 1,
                                                      "controls-position":
                                                        "right",
                                                      max: 999999,
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .stock,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "stock",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].stock",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "fictitious"
                                              ? [_vm._v(" -- ")]
                                              : item.slot === "barCode"
                                              ? [
                                                  _c("el-input", {
                                                    staticClass: "priceBox",
                                                    attrs: { maxlength: "40" },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .barCode,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "barCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].barCode",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "itemNumber" &&
                                                _vm.formValidate.type ===
                                                  _vm.OrderSecondTypeEnum.Normal
                                              ? [
                                                  _c("el-input", {
                                                    staticClass: "priceBox",
                                                    attrs: { maxlength: "40" },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .itemNumber,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "itemNumber",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].itemNumber",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "weight" &&
                                                _vm.formValidate.type !==
                                                  _vm.OrderSecondTypeEnum
                                                    .Reservation
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      step: 0.1,
                                                      min: 0,
                                                      max: 999999,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .weight,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "weight",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].weight",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "volume" &&
                                                _vm.formValidate.type !==
                                                  _vm.OrderSecondTypeEnum
                                                    .Reservation
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      step: 0.1,
                                                      min: 0,
                                                      max: 999999,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .volume,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "volume",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].volume",
                                                    },
                                                  }),
                                                ]
                                              : item.slot ===
                                                  "attrValueReservationList" &&
                                                _vm.formValidate.type ===
                                                  _vm.OrderSecondTypeEnum
                                                    .Reservation
                                              ? [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      class: {
                                                        flash: _vm.isFlashing,
                                                      },
                                                      attrs: {
                                                        size: "small",
                                                        disabled:
                                                          _vm.isDisabled,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleSetReservationNum(
                                                            scope.$index,
                                                            _vm.ManyAttrValue,
                                                            "batch"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("批量可约数量")]
                                                  ),
                                                ]
                                              : item.slot === "isDefault"
                                              ? [_vm._v(" -- ")]
                                              : item.slot === "action"
                                              ? [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        type: "text",
                                                        size: "mini",
                                                      },
                                                      on: {
                                                        click: _vm.batchAdd,
                                                      },
                                                    },
                                                    [_vm._v("批量修改")]
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "ml10",
                                                      attrs: {
                                                        type: "text",
                                                        size: "mini",
                                                      },
                                                      on: {
                                                        click: _vm.batchDel,
                                                      },
                                                    },
                                                    [_vm._v("清空")]
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ]
                                        : [
                                            item.key
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row
                                                              .attrValueShow[
                                                              item.key
                                                            ]
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                            item.slot === "image"
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "upLoadPicBox specPictrue",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.modalPicTap(
                                                            false,
                                                            "duo",
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      scope.row.image
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad tabPic",
                                                            },
                                                            [
                                                              _c("el-image", {
                                                                attrs: {
                                                                  src: scope.row
                                                                    .image,
                                                                  "preview-src-list":
                                                                    _vm.isDisabled
                                                                      ? [
                                                                          scope
                                                                            .row
                                                                            .image,
                                                                        ]
                                                                      : [],
                                                                  fit: "cover",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad tabPic",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-camera cameraIconfont",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "24px",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                            item.slot === "price"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0.01,
                                                      max: 999999.99,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].price,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "price",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].price",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "vipPrice" &&
                                                _vm.formValidate.vipPriceType
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0.01,
                                                      max: 999999.99,
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].vipPrice,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "vipPrice",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].vipPrice",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "cost"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0.01,
                                                      max: 999999.99,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].cost,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "cost",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].cost",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "otPrice"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0.01,
                                                      max: 999999.99,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].otPrice,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "otPrice",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].otPrice",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "stock" &&
                                                _vm.formValidate.type !==
                                                  _vm.OrderSecondTypeEnum
                                                    .Reservation
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      disabled:
                                                        _vm.formValidate
                                                          .type ===
                                                        _vm.OrderSecondTypeEnum
                                                          .CardPassword
                                                          ? true
                                                          : false,
                                                      min: 0,
                                                      max: 999999,
                                                      precision: 0,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].stock,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "stock",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].stock",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "barCode"
                                              ? [
                                                  _c("el-input", {
                                                    staticClass: "priceBox",
                                                    attrs: { maxlength: "40" },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].barCode,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "barCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].barCode",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "itemNumber" &&
                                                _vm.formValidate.type ===
                                                  _vm.OrderSecondTypeEnum.Normal
                                              ? [
                                                  _c("el-input", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      maxlength: "40",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].itemNumber,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "itemNumber",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].itemNumber",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "brokerage" &&
                                                _vm.formValidate.isSub
                                              ? [
                                                  _c("el-input", {
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].brokerage,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "brokerage",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].brokerage",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "brokerageTwo" &&
                                                _vm.formValidate.isSub
                                              ? [
                                                  _c("el-input", {
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].brokerageTwo,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "brokerageTwo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].brokerageTwo",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "weight" &&
                                                _vm.formValidate.type !==
                                                  _vm.OrderSecondTypeEnum
                                                    .Reservation
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      step: 0.1,
                                                      max: 999999,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].weight,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "weight",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].weight",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "volume" &&
                                                _vm.formValidate.type !==
                                                  _vm.OrderSecondTypeEnum
                                                    .Reservation
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      step: 0.1,
                                                      min: 0,
                                                      max: 999999,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].volume,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "volume",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].volume",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "fictitious" &&
                                                _vm.formValidate.type ==
                                                  _vm.OrderSecondTypeEnum
                                                    .CloudDrive
                                              ? [
                                                  _c(
                                                    "div",
                                                    [
                                                      !scope.row.expand
                                                        ? _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                size: "small",
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleAddVirtually(
                                                                      scope.$index,
                                                                      "ManyAttrValue",
                                                                      1
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("添加链接")]
                                                          )
                                                        : _c(
                                                            "el-button",
                                                            {
                                                              staticClass:
                                                                "seeCatMy pointer",
                                                              attrs: {
                                                                type: "text",
                                                                size: "small",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.seeVirtually(
                                                                      _vm
                                                                        .ManyAttrValue[
                                                                        scope
                                                                          .$index
                                                                      ],
                                                                      "ManyAttrValue",
                                                                      scope.$index,
                                                                      1
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("已设置")]
                                                          ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              : item.slot === "fictitious" &&
                                                _vm.formValidate.type ==
                                                  _vm.OrderSecondTypeEnum
                                                    .CardPassword
                                              ? [
                                                  _c(
                                                    "div",
                                                    [
                                                      !scope.row.cdkeyId
                                                        ? _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                size: "small",
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleAddVirtually(
                                                                      scope.$index,
                                                                      "ManyAttrValue",
                                                                      2
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("添加卡密")]
                                                          )
                                                        : _c(
                                                            "el-button",
                                                            {
                                                              staticClass:
                                                                "seeCatMy pointer",
                                                              attrs: {
                                                                type: "text",
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.seeVirtually(
                                                                      _vm
                                                                        .ManyAttrValue[
                                                                        scope
                                                                          .$index
                                                                      ],
                                                                      "ManyAttrValue",
                                                                      scope.$index,
                                                                      2
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .cdkeyLibraryName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              : item.slot ===
                                                  "attrValueReservationList" &&
                                                _vm.formValidate.type ===
                                                  _vm.OrderSecondTypeEnum
                                                    .Reservation
                                              ? [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      class: {
                                                        flash: _vm.isFlashing,
                                                      },
                                                      attrs: {
                                                        size: "small",
                                                        disabled:
                                                          _vm.isDisabled,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleSetReservationNum(
                                                            scope.$index,
                                                            _vm.ManyAttrValue
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("设置可约数量")]
                                                  ),
                                                ]
                                              : item.slot === "isDefault"
                                              ? [
                                                  _c("el-switch", {
                                                    attrs: {
                                                      "active-value": true,
                                                      "inactive-value": false,
                                                      "active-text": "默认",
                                                      disabled: _vm.isDisabled,
                                                    },
                                                    on: {
                                                      change: function (e) {
                                                        return _vm.changeDefaultSelect(
                                                          e,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].isDefault,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "isDefault",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].isDefault",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "action"
                                              ? [
                                                  _c("el-switch", {
                                                    staticClass: "defineSwitch",
                                                    attrs: {
                                                      "active-text": "显示",
                                                      "inactive-text": "隐藏",
                                                      "active-value": true,
                                                      "inactive-value": false,
                                                      disabled: _vm.isDisabled,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.changeDefaultShow(
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].isShow,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "isShow",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].isShow",
                                                    },
                                                  }),
                                                ]
                                              : _vm._e(),
                                          ],
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("add-cloud-disk", {
        ref: "cloudDiskRef",
        attrs: { cloudDisk: _vm.cloudDisk },
        on: {
          handlerSubSuccess: _vm.handlerSubSuccessCloudDisk,
          closeCloudDisk: _vm.closeCloudDisk,
        },
      }),
      _c("cdkey-library", {
        ref: "cdkeyLibraryRef",
        attrs: { cdkeyLibraryInfo: _vm.cdkeyLibraryInfo },
        on: { handlerSubSuccess: _vm.handlerChangeCdkeyIdSubSuccess },
      }),
      _c("reservationStockDialog", {
        ref: "reservationStock",
        attrs: {
          dialogVisible: _vm.dialogVisible,
          reservationData: _vm.reservationData,
          specType: _vm.formValidate.specType,
        },
        on: { submitOk: _vm.handleSubmitOk, close: _vm.handleClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }